export const distance = (v) => {
  if(typeof v === 'number' && !isNaN(v)){
    if(v < 0.001){
      return '少于1米'
    }else if(v < 1){
      return Math.round(v * 1000) + '米'
    }else{
      return v.toFixed(2)+'公里'
    }
  }else{
    return 'n/a'
  }
}

export default distance